<sirius-sidebar [selectedItem]="rootItem" (menuClose)="menuClose.emit()"></sirius-sidebar>
